import React from 'react';
import { Star, Quote } from 'lucide-react';

interface Testimonial {
  id: string;
  name: string;
  location: string;
  rating: number;
  text: string;
  image?: string;
  homeBuilt?: string;
}

const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Sarah & Mike Johnson',
    location: 'Rolleston, Canterbury',
    rating: 5,
    text: 'Rolleston Homes exceeded our expectations in every way. From the initial consultation to the final walkthrough, their attention to detail and commitment to quality was outstanding. Our Allegra 355 is everything we dreamed of and more.',
    homeBuilt: 'Allegra 355'
  },
  {
    id: '2',
    name: 'Emma Thompson',
    location: 'Lincoln, Canterbury',
    rating: 5,
    text: 'The team at Rolleston Homes made our home building journey stress-free and enjoyable. Their communication was excellent, and they delivered on time and within budget. We absolutely love our new Grandview family home.',
    homeBuilt: 'Grandview 420'
  },
  {
    id: '3',
    name: 'David & Lisa Chen',
    location: 'Prebbleton, Canterbury',
    rating: 5,
    text: 'Choosing Rolleston Homes was the best decision we made. Their Kiwiana homes perfectly capture the essence of New Zealand living. The craftsmanship is exceptional, and the design is both beautiful and functional.',
    homeBuilt: 'Kauri Cottage 250'
  }
];

const Testimonials: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1280px] mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1F2937] mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-[#334155] max-w-2xl mx-auto">
            Don't just take our word for it. Here's what families across Canterbury are saying about their Rolleston Homes experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-[#FAFAFA] rounded-2xl p-8 relative">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#FF5A1F]/20" />
              
              {/* Rating */}
              <div className="flex items-center space-x-1 mb-4">
                {Array.from({ length: 5 }).map((_, index) => (
                  <Star
                    key={index}
                    className={`w-5 h-5 ${
                      index < testimonial.rating
                        ? 'text-yellow-400 fill-current'
                        : 'text-gray-300'
                    }`}
                  />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-[#334155] mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Client Info */}
              <div className="border-t border-gray-200 pt-4">
                <div className="font-semibold text-[#1F2937]">{testimonial.name}</div>
                <div className="text-sm text-[#334155]">{testimonial.location}</div>
                {testimonial.homeBuilt && (
                  <div className="text-sm text-[#FF5A1F] font-medium mt-1">
                    Built: {testimonial.homeBuilt}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-lg text-[#334155] mb-6">
            Ready to start your own success story?
          </p>
          <a
            href="/contact"
            className="inline-flex items-center space-x-2 bg-[#FF5A1F] text-white px-8 py-4 rounded-2xl font-bold text-lg hover:bg-[#e4501c] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            <span>Get Started Today</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;